import axios from 'axios'

export default {
  namespaced: true,
  state: {
    ceramics: sessionStorage.getItem('ceramics') ? JSON.parse(sessionStorage.getItem('ceramics')) : false
  },
  mutations: {
    fetch(state, ceramics) {
      state.ceramics = ceramics
      sessionStorage.setItem('ceramics', JSON.stringify(ceramics))
    },
    reset(state) {
      state.ceramics = false
      sessionStorage.removeItem('ceramics')
    }
  },
  actions: {
    async fetch({
      commit,
      state
    }) {
      if (!state.ceramics) {
        const res = await axios({
          url: '/business/ceramic/?audit=1&visible=1',
          method: 'GET'
        })
        commit('fetch', res.data)
      }
    },
    reset({
      commit
    }) {
      commit('reset')
    }
  },
  getters: {
    ceramics: (state) => {
      return state.ceramics || []
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/CeramicsStore.js